module.exports = __webpack_public_path__ + "img/fourth_door_on.b9da696c.png";